/**
 * Substitute {placeholders} in a localized string.
 *
 *   fmt('Sent to {sent} of {total}', { sent: 2, total: 3 }) → 'Sent to 2 of 3'
 *
 * Missing values are left as-is so an untranslated key is obvious in the UI
 * rather than rendering "undefined".
 */
export function fmt(template, values = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match
  );
}
